import React, { PropsWithChildren } from 'react'

const TableBody: React.FC <PropsWithChildren> = ({ children }) => {

    return <tbody>{children}</tbody>

}

export default TableBody